import React from 'react';
import { useNavigate } from 'react-router-dom';
import pb from '../../services/pocketbase';
import { useCart } from '../../context/CartContext';
import { useFavorites } from '../../context/FavoritesContext';
import './OrderSummaryModal.css';

function OrderSummaryModal({ isOpen, onClose, items, total, type = 'cart' }) {
  const navigate = useNavigate();

  const { isCartOpen, toggleCart } = useCart();
  const { isSidebarOpen, toggleSidebar } = useFavorites();

  const getImageUrl = (item) => {
    const imageName = Array.isArray(item.image) ? item.image[0] : item.image;
    if (item && imageName && item.collectionId && item.id) {
      return pb.files.getURL({
        collectionId: item.collectionId,
        id: item.id
      }, imageName, {'thumb': '100x100'});
    }
    return 'https://via.placeholder.com/100';
  };

  const handleContinue = () => {
    // 1. Fermer d'abord la modale
    onClose();
    
    // 2. Fermer le tiroir du panier s'il est ouvert
    if (isCartOpen) {
      toggleCart();
    }
    
    // 3. Fermer le tiroir des favoris s'il est ouvert
    if (isSidebarOpen) {
      toggleSidebar();
    }

    // 4. Naviguer et remonter en haut de page après un court délai pour l'animation
    setTimeout(() => {
      navigate('/contact');
      window.scrollTo(0, 0);
    }, 300);
  };

  if (!isOpen) return null;

  return (
    <div className="order-modal-overlay" onClick={onClose}>
      <div className="order-modal" onClick={(e) => e.stopPropagation()}>
        <div className="order-modal-header">
          <h2>📋 Récapitulatif de votre {type === 'cart' ? 'panier' : 'sélection'}</h2>
          <button className="order-modal-close" onClick={onClose}>&times;</button>
        </div>
        
        <div className="order-modal-content">
          <div className="order-items-list">
            {items.map(item => (
              <div key={item.id} className="order-item">
                <img 
                  src={getImageUrl(item)} 
                  alt={item.name}
                  className="order-item-image"
                />
                <div className="order-item-details">
                  <h4>{item.name}</h4>
                  <div className="order-item-price">
                    {type === 'cart' && item.quantity > 1 && (
                      <span className="quantity">Quantité: {item.quantity}</span>
                    )}
                    <span className="price">
                      {type === 'cart' 
                        ? `${((item.price || 0) * item.quantity).toFixed(2).replace('.', ',')} €`
                        : `${(item.price || 0).toFixed(2).replace('.', ',')} €`
                      }
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="order-summary">
            <div className="order-total">
              <span>Total des articles :</span>
              <span className="total-amount">{total.toFixed(2).replace('.', ',')} €</span>
            </div>
            <div className="shipping-info">
              <p>📦 <strong>Livraison :</strong> Frais de livraison à ajouter</p>
              <p>📍 <strong>Méthodes :</strong> Colissimo, Point Relais</p>
              <p>💳 <strong>Paiement :</strong> Lien sécurisé envoyé par email</p>
            </div>
          </div>
          
          <div className="order-process-info">
            <h3>🎯 Prochaines étapes :</h3>
            <ol>
              <li>Contactez-moi directement par <strong>email</strong> ou par <strong>téléphone</strong></li>
              <li>Précisez les articles souhaités et votre adresse de livraison</li>
              <li>Je vous enverrai un devis complet avec les frais de port</li>
              <li>Validez votre commande via le lien de paiement sécurisé</li>
            </ol>
          </div>
        </div>
        
        <div className="order-modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            Retour
          </button>
          <button className="btn-continue" onClick={handleContinue}>
            Contactez-moi pour commander →
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderSummaryModal;
